howspace.components.keyboard = (() => {
    'use strict';

    return {
        onItemGroupKeyDown : function(e, parentSelector, itemSelector, changeFn, selectFn) {
            const item = $(e.target).closest(itemSelector);

            switch (e.key) {
                case 'ArrowUp':
                case 'ArrowLeft': {
                    e.preventDefault();

                    let previousItem = item.prev(itemSelector);
                    if (previousItem.length === 0) {
                        previousItem = item.closest(parentSelector).find(itemSelector).last();
                    }
                    previousItem.focus();

                    changeFn(previousItem);
                    break;
                }

                case 'ArrowDown':
                case 'ArrowRight': {
                    e.preventDefault();

                    let nextItem = item.next(itemSelector);
                    if (nextItem.length === 0) {
                        nextItem = item.closest(parentSelector).find(itemSelector).first();
                    }
                    nextItem.focus();

                    changeFn(nextItem);
                    break;
                }

                case 'Enter':
                case ' ':
                    e.preventDefault();

                    selectFn(item);
                    break;
            }
        }
    };
})();
